module.exports = __webpack_public_path__ + "img/img4037.bbfcad3a.jpg";